import React from "react";
import clsx from "clsx";

import styles from "./separator.module.scss";

const Separator = () => <hr className={clsx(styles.separator)} />;

export default Separator;
